export const settings_plan_usage_en = {
  settings_plan_usage_title: "Plan & Usage",
  settings_plan_usage_desc:
    "Manage your referral rewards effortlessly from this page. Track your lifetime earnings, view available and withdrawn amounts, and see detailed referral activity. You can also review your withdrawal history and monitor users you've successfully referred.",
  settings_plan_usage_credits_usage: "Credit History",
  used_total_remaining: "Used/Total (Remaining)",

  settings_plan_usage_error_tooltip:
    "You've reached your limit. Upgrade/top-up to unlock more.",
  settings_plan_usage_warning_tooltip:
    "You're getting close to your limit. Consider upgrading/top-up for more access.",
  used: "used",
  left: "left",
  calls: "calls",
  settings_plan_usage_topup_credits_desc:
    "Extra purchased credits that never expire",
  settings_plan_usage_auto_topup_title: "Auto Top-Up",
  settings_plan_usage_auto_topup_desc:
    "Automatically refill your credit balance when it falls below a set threshold. Stay uninterrupted and keep your tasks running smoothly without manual top-ups.",
  settings_plan_usage_manual_topup_title: "Manual Top-Up",
  settings_plan_usage_manual_topup_desc:
    "Add credits to your account as needed. Enter the amount, review the cost, and confirm.",
  settings_plan_usage_manual_topup_credit_amount: "Credit amount",
  settings_plan_usage_manual_topup_price_per_credit: "Price per credit",
  settings_plan_usage_manual_topup_total: "Total price:",
  settings_plan_usage_manual_topup_button: "Proceed to Top-up",
  settings_plan_usage_manual_topup_tip:
    "You’ll confirm before the payment is charged",
  "plan-usage": "Plan & Usage",
  settings_plan_usage_credits_history_column_date_time: "Date & Time",
  settings_plan_usage_credits_history_column_credits_out: "Credits Out",

  credits_price: "Credit price:",
};

export const settings_plan_usage_zhCN = {
  settings_plan_usage_title: "套餐与使用情况",
  settings_plan_usage_desc:
    "在此页面轻松管理您的推荐奖励。追踪您的终身收益，查看可用和已提现金额，以及详细的推荐活动。您还可以查看提现历史记录并监控您成功推荐的用户。",
  settings_plan_usage_credits_usage: "积分历史",
  used_total_remaining: "已用/总量（剩余）",

  settings_plan_usage_error_tooltip: "您已达到限制。升级/充值以解锁更多功能。",
  settings_plan_usage_warning_tooltip:
    "您已接近限制。考虑升级/充值以获得更多访问权限。",
  used: "已用",
  left: "剩余",
  calls: "调用次数",
  settings_plan_usage_topup_credits_desc: "额外购买的积分永不过期",
  settings_plan_usage_auto_topup_title: "自动充值",
  settings_plan_usage_auto_topup_desc:
    "当余额低于设定阈值时自动补充积分。无需手动充值，保持任务不间断运行。",
  settings_plan_usage_manual_topup_title: "手动充值",
  settings_plan_usage_manual_topup_desc:
    "根据需要向账户添加积分。输入金额，查看费用并确认。",
  settings_plan_usage_manual_topup_credit_amount: "积分数量",
  settings_plan_usage_manual_topup_price_per_credit: "每积分价格",
  settings_plan_usage_manual_topup_total: "总价：",
  settings_plan_usage_manual_topup_button: "继续充值",
  settings_plan_usage_manual_topup_tip: "支付前您需要确认",
  "plan-usage": "套餐与使用情况",
  settings_plan_usage_credits_history_column_date_time: "日期和时间",
  settings_plan_usage_credits_history_column_credits_out: "积分支出",
  credits_price: "积分价格:",
};

export const settings_plan_usage_zhTW = {
  settings_plan_usage_title: "方案與使用情況",
  settings_plan_usage_desc:
    "在此頁面輕鬆管理您的推薦獎勵。追蹤您的終身收益，查看可用和已提現金額，以及詳細的推薦活動。您還可以查看提現歷史記錄並監控您成功推薦的用戶。",
  settings_plan_usage_credits_usage: "點數歷史",
  used_total_remaining: "已用/總量（剩餘）",

  settings_plan_usage_error_tooltip: "您已達到限制。升級/儲值以解鎖更多功能。",
  settings_plan_usage_warning_tooltip:
    "您已接近限制。考慮升級/儲值以獲得更多存取權限。",
  used: "已用",
  left: "剩餘",
  calls: "呼叫次數",
  settings_plan_usage_topup_credits_desc: "額外購買的點數永不過期",
  settings_plan_usage_auto_topup_title: "自動儲值",
  settings_plan_usage_auto_topup_desc:
    "當餘額低於設定閾值時自動補充點數。無需手動儲值，保持任務不間斷運行。",
  settings_plan_usage_manual_topup_title: "手動儲值",
  settings_plan_usage_manual_topup_desc:
    "根據需要向帳戶添加點數。輸入金額，查看費用並確認。",
  settings_plan_usage_manual_topup_credit_amount: "點數數量",
  settings_plan_usage_manual_topup_price_per_credit: "每點數價格",
  settings_plan_usage_manual_topup_total: "總價：",
  settings_plan_usage_manual_topup_button: "繼續儲值",
  settings_plan_usage_manual_topup_tip: "支付前您需要確認",
  "plan-usage": "方案與使用情況",
  settings_plan_usage_credits_history_column_date_time: "日期和時間",
  settings_plan_usage_credits_history_column_credits_out: "點數支出",
  credits_price: "點數價格:",
};

export const settings_plan_usage_ja = {
  settings_plan_usage_title: "プランと使用状況",
  settings_plan_usage_desc:
    "このページから紹介報酬を簡単に管理できます。生涯収益を追跡し、利用可能な金額と引き出した金額を表示し、詳細な紹介活動を確認できます。また、出金履歴を確認し、正常に紹介したユーザーを監視することもできます。",
  settings_plan_usage_credits_usage: "クレジット履歴",
  used_total_remaining: "使用済み/合計（残り）",

  settings_plan_usage_error_tooltip:
    "制限に達しました。アップグレード/トップアップしてさらに機能を解放してください。",
  settings_plan_usage_warning_tooltip:
    "制限に近づいています。より多くのアクセス権を得るためにアップグレード/トップアップを検討してください。",
  used: "使用済み",
  left: "残り",
  calls: "コール数",
  settings_plan_usage_topup_credits_desc:
    "追加購入したクレジットは永久に有効です",
  settings_plan_usage_auto_topup_title: "自動トップアップ",
  settings_plan_usage_auto_topup_desc:
    "残高が設定されたしきい値を下回ったときに自動的にクレジット残高を補充します。手動でのトップアップなしで、中断なくタスクをスムーズに実行し続けます。",
  settings_plan_usage_manual_topup_title: "手動トップアップ",
  settings_plan_usage_manual_topup_desc:
    "必要に応じてアカウントにクレジットを追加します。金額を入力し、費用を確認して承認します。",
  settings_plan_usage_manual_topup_credit_amount: "クレジット数量",
  settings_plan_usage_manual_topup_price_per_credit: "クレジット単価",
  settings_plan_usage_manual_topup_total: "合計金額：",
  settings_plan_usage_manual_topup_button: "トップアップに進む",
  settings_plan_usage_manual_topup_tip: "支払いの前に確認が必要です",
  "plan-usage": "プランと使用状況",
  settings_plan_usage_credits_history_column_date_time: "日付と時間",
  settings_plan_usage_credits_history_column_credits_out: "クレジット支出",
  credits_price: "クレジット単価:",
};

export const settings_plan_usage_ko = {
  settings_plan_usage_title: "플랜 및 사용량",
  settings_plan_usage_desc:
    "이 페이지에서 추천 보상을 쉽게 관리하세요. 평생 수익을 추적하고, 사용 가능한 금액과 인출된 금액을 확인하며, 상세한 추천 활동을 볼 수 있습니다. 또한 인출 내역을 검토하고 성공적으로 추천한 사용자를 모니터링할 수도 있습니다.",
  settings_plan_usage_credits_usage: "크레딧 내역",
  used_total_remaining: "사용됨/총량 (남음)",

  settings_plan_usage_error_tooltip:
    "한도에 도달했습니다. 더 많은 기능을 잠금 해제하려면 업그레이드/충전하세요.",
  settings_plan_usage_warning_tooltip:
    "한도에 가까워지고 있습니다. 더 많은 액세스 권한을 위해 업그레이드/충전을 고려하세요.",
  used: "사용됨",
  left: "남음",
  calls: "호출 횟수",
  settings_plan_usage_topup_credits_desc:
    "추가 구매한 크레딧은 만료되지 않습니다",
  settings_plan_usage_auto_topup_title: "자동 충전",
  settings_plan_usage_auto_topup_desc:
    "잔액이 설정된 임계값 아래로 떨어지면 자동으로 크레딧 잔액을 충전합니다. 수동 충전 없이 중단 없이 작업을 원활하게 실행하세요.",
  settings_plan_usage_manual_topup_title: "수동 충전",
  settings_plan_usage_manual_topup_desc:
    "필요에 따라 계정에 크레딧을 추가합니다. 금액을 입력하고 비용을 검토한 후 확인합니다.",
  settings_plan_usage_manual_topup_credit_amount: "크레딧 수량",
  settings_plan_usage_manual_topup_price_per_credit: "크레딧 단가",
  settings_plan_usage_manual_topup_total: "총 가격:",
  settings_plan_usage_manual_topup_button: "충전 진행",
  settings_plan_usage_manual_topup_tip: "결제 전에 확인하시게 됩니다",
  "plan-usage": "플랜 및 사용량",
  settings_plan_usage_credits_history_column_date_time: "날짜 및 시간",
  settings_plan_usage_credits_history_column_credits_out: "크레딧 지출",
  credits_price: "크레딧 단가:",
};

export const settings_plan_usage_hi = {
  settings_plan_usage_title: "प्लान और उपयोग",
  settings_plan_usage_desc:
    "इस पेज से आसानी से अपने रेफरल पुरस्कार प्रबंधित करें। अपनी आजीवन कमाई ट्रैक करें, उपलब्ध और निकाली गई राशि देखें, और विस्तृत रेफरल गतिविधि देखें। आप अपना निकासी इतिहास भी समीक्षा कर सकते हैं और सफलतापूर्वक रेफर किए गए उपयोगकर्ताओं की निगरानी कर सकते हैं।",
  settings_plan_usage_credits_usage: "क्रेडिट इतिहास",
  used_total_remaining: "उपयोग/कुल (शेष)",

  settings_plan_usage_error_tooltip:
    "आप अपनी सीमा तक पहुँच गए हैं। अधिक अनलॉक करने के लिए अपग्रेड/टॉप-अप करें।",
  settings_plan_usage_warning_tooltip:
    "आप अपनी सीमा के करीब पहुँच रहे हैं। अधिक पहुंच के लिए अपग्रेड/टॉप-अप पर विचार करें。",
  used: "उपयोग",
  left: "शेष",
  calls: "कॉल",
  settings_plan_usage_topup_credits_desc:
    "अतिरिक्त खरीदे गए क्रेडिट कभी समाप्त नहीं होते",
  settings_plan_usage_auto_topup_title: "ऑटो टॉप-अप",
  settings_plan_usage_auto_topup_desc:
    "जब यह एक सेट थ्रेशोल्ड से नीचे गिरता है तो अपने क्रेडिट बैलेंस को स्वचालित रूप से रीफिल करें। मैन्युअल टॉप-अप के बिना निर्बाध रहें और अपने कार्यों को सुचारू रूप से चलाते रहें।",
  settings_plan_usage_manual_topup_title: "मैन्युअल टॉप-अप",
  settings_plan_usage_manual_topup_desc:
    "आवश्यकतानुसार अपने खाते में क्रेडिट जोड़ें। राशि दर्ज करें, लागत की समीक्षा करें और पुष्टि करें।",
  settings_plan_usage_manual_topup_credit_amount: "क्रेडिट राशि",
  settings_plan_usage_manual_topup_price_per_credit: "प्रति क्रेडिट मूल्य",
  settings_plan_usage_manual_topup_total: "कुल मूल्य:",
  settings_plan_usage_manual_topup_button: "टॉप-अप के लिए आगे बढ़ें",
  settings_plan_usage_manual_topup_tip:
    "भुगतान चार्ज होने से पहले आप पुष्टि करेंगे",
  "plan-usage": "प्लान और उपयोग",
  settings_plan_usage_credits_history_column_date_time: "तिथि और समय",
  settings_plan_usage_credits_history_column_credits_out: "क्रेडिट आउट",
  credits_price: "क्रेडिट मूल्य:",
};
